import moment from "moment";
import "moment/locale/ru";
import i18n from '../translations/config'
import {IFilter} from "../interface/Basic/window";

// moment.locale('ru');
moment.locale(i18n.language);

/* 10:00 */
export function time(dateTimeStart: string): string {
    return moment(dateTimeStart).isValid() ? moment(dateTimeStart).add(3, 'hours').format('HH:mm') : ''
}

/* 19 января, 10:00 */
export function dateTime(dateTimeStart: string): string {
    return moment(dateTimeStart).isValid() ? moment(dateTimeStart).add(3, 'hours').format('DD MMMM, HH:mm') : ''
}

/* 19 января 2021, 10:00 */
export function dateTime2(dateTimeStart: string): string {
    return moment(dateTimeStart).isValid() ? moment(dateTimeStart).add(3, 'hours').format('DD MMMM YYYY, HH:mm') : ''
}

/* 19 янв 2021, 10:00 */
export function dateTime3(dateTimeStart: string): string {
    return moment(dateTimeStart).isValid() ? moment(dateTimeStart).add(3, 'hours').format('DD MMM YYYY, HH:mm') : ''
}

/* 10:00 - 12:00 */
export function timeInterval(dateTimeStart: string, dateTimeEnd: string): string {
    return moment(dateTimeStart).add(3, 'hours').format('HH:mm') +
        ' - ' + moment(dateTimeEnd).add(3, 'hours').format('HH:mm');
}

/* 1 сентября - 29 января или 1 - 29 января */
export function dateInterval(dateTimeStart: string, dateTimeEnd: string): string {
    const isSameMonth = moment(dateTimeStart).isSame(dateTimeEnd, 'month');
    if (!isSameMonth) {
        return moment(dateTimeStart).add(3, 'hours').format('D MMMM ') +
            ' - ' + moment(dateTimeEnd).add(3, 'hours').format('D MMMM');
    }
    return moment(dateTimeStart).add(3, 'hours').format('D ') +
        ' - ' + moment(dateTimeEnd).add(3, 'hours').format('D MMMM');
}

/* 1 января 10:00 - 12:00 */
export function dateTimeInterval(dateTimeStart: string, dateTimeEnd: string): string {
    const date = moment(dateTimeStart).isValid() ? moment(dateTimeStart).add(3, 'hours').format('D MMMM ') : ''
    const interval = timeInterval(dateTimeStart, dateTimeEnd)
    return date + interval
}


/* 1 января в 10:00 (без перевода в МСК) */
export function dateAndTime(date: string, time: string): string {
    const datetime = date + ' ' + time
    if (moment(datetime).isValid() && moment().locale() === 'ru') {
        return moment(date + ' ' + time).format('DD MMM YYYY') + ' в ' + moment(datetime).format('HH:mm')
    }
    if (moment(datetime).isValid() && moment().locale() === 'en') {
        return moment(datetime).format('DD MMM YYYY ') + moment(datetime).format('HH:mm')
    }
    return ''
}

/* 01.01.2020 */
export function date(date: string): string {
    return moment(date).isValid() ? moment(date).format('DD.MM.YYYY') : ''
}

/* 8:00-17:00 */
export function timeRangeFromDuration(durationStart: number, durationEnd: number): string {
    return moment.utc().startOf('day').add(durationStart, 'minutes').format('HH:mm') + '-'
        + moment.utc().startOf('day').add(durationEnd, 'minutes').format('HH:mm')
}

/* 10.02.2020 -> 2020-02-10 */
export function convertDate(date: string): string {
    const dateArray = date.split('.')
    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
}

export function getYear(date: Date): number {
    return moment(date).isValid() ? +moment().format('YYYY') : 2000
}

export function range(start: number, end: number): IFilter[] {

    const range: number[] = []

    for (let i = start; i < end; i++) {
        range.push(i)
    }

    return range.map((item, index) => {
        return {
            id: index,
            name: item.toString()
        }
    }).reverse()

}


export function yearRange(start: number, end: number): IFilter[] {
    const range: number[] = []
    for (let i = start; i < end; i++) {
        range.push(i)
    }
    return range.map((item) => (
        {
            id: item,
            name: item.toString()
        })).reverse()
}